import {
  PayoutStatusSchema,
  type PayoutStatus as GeneratedPayoutStatus
} from '~/services/api/generated'

// Mirrors backend App\Enums\Payment\PayoutStatus

export type PayoutStatus = GeneratedPayoutStatus

export const PayoutStatus = {
  PENDING: PayoutStatusSchema.enum.pending,
  PROCESSING: PayoutStatusSchema.enum.processing,
  COMPLETED: PayoutStatusSchema.enum.completed,
  FAILED: PayoutStatusSchema.enum.failed,
  CANCELLED: PayoutStatusSchema.enum.cancelled
} satisfies Record<string, GeneratedPayoutStatus>

export const PayoutStatusValues: readonly GeneratedPayoutStatus[] = [
  PayoutStatusSchema.enum.pending,
  PayoutStatusSchema.enum.processing,
  PayoutStatusSchema.enum.completed,
  PayoutStatusSchema.enum.failed,
  PayoutStatusSchema.enum.cancelled
]
